import type { PopoverRequiredFields } from '@/components/_SiteWide/MapboxMap/types'
import type { MAP_STYLE_OPTIONS } from './constants'
import { LocationType } from '@/api/useMetadata/types'
import type { PointsOfInterestResponse } from '../../types'

export type PopoverInfo =
  | (PopoverRequiredFields & {
      popoverType: 'breadcrumb'
      timestamp: string
      trigger: string
      timezone: string
    })
  | (PopoverRequiredFields & {
      popoverType: 'load-drop'
      timestamp: string
      name: string
      action: 'loading' | 'dropping'
      productMovements: string // JSON stringified array of ProductMovement
      timezone: string
    })
  | (PopoverRequiredFields & {
      popoverType: 'poi'
      location: string
      siteName: string | null | undefined
      address: string | null | undefined
      city: string | null | undefined
      state: string | null | undefined
      postalCode: string | null | undefined
      locationType: PointsOfInterestResponse[PoiTypes][number]['type']
      radius?: number
    })
  | (PopoverRequiredFields & {
      popoverType: 'arrival-departure'
      timestamp: string
      action: 'loading' | 'dropping'
      event: 'arrival' | 'departure'
      locationName: string
      timezone: string
    })
  | (PopoverRequiredFields & {
      popoverType: 'driver'
      driverName: string
      orderNumber: string
      action: string | null | undefined
      lastHeartbeat: string | null | undefined
      eta: string | null | undefined
      timezone: string
      complete: boolean
    })

export type MapStyle = keyof typeof MAP_STYLE_OPTIONS

export type PoiTypes = 'terminals' | 'depots' | 'sites'

export const MapFilterKeys = ['counterparty_name', 'sector', 'state', 'city', 'postal_code', 'customer_name'] as const
export const SiteOnlyKeys = ['counterparty_name', 'customer_name'] as const

export type FilterObject = {
  [K in (typeof MapFilterKeys)[number]]: string[]
}

export type MapFilters = {
  sites: FilterObject
  terminals: Omit<FilterObject, (typeof SiteOnlyKeys)[number]>
  depots: Omit<FilterObject, (typeof SiteOnlyKeys)[number]>
}

export type MapSettings = {
  style: MapStyle
  showBreadcrumbs: boolean
  showLocations: 'all' | 'only_on_route' | 'none'
}

export type SiteSearchOption = {
  label: string
  value: string
  locationName: string
  siteName: string
  counterparty: string
}
